import axios from "axios";

const getUser = () => axios.get('/api/enduser/profile');
const getUserIds = () => axios.get('/api/enduser/ids');
const downloadUserId = (id) => axios.get('/api/enduser/ids/' + id + '/download', { responseType: 'blob' });
const getUserWithDate = () => axios.get('/api/enduser/profile');

const getUserContract = (type) => axios.get('/api/enduser/contract/'+type, { responseType: 'blob' });

const streamUserContract = (type) => axios.get('/api/enduser/contract/'+type+'/print', { responseType: 'blob' })

const downloadUserContract = (type) => axios.get('/api/enduser/contract/'+type+'/download', { responseType: 'blob' })

const getUserContracts = () => axios.get('/api/enduser/contract/list');
const getFeeList = () => axios.get('/api/enduser/get-fees');

const signContract = (type, phone) => axios.post('/user/contract/sign', { type, phone });
const signContractWithoutGsign = () => axios.post('/api/enduser/contract/without/sign');
const signContractDrawn = (type, signature, signature_type) => {
  const form = new FormData()
  form.append('type', type)
  form.append('signature', signature)
  form.append('signature_type', signature_type)
  return axios.post('/api/enduser/contract/sign/drawn', form)
};
// Гарын үсэг зурсан гэрээний файлыг S3-аас авна. Contract file биш, гэрээний id-г дамжуулна.
const downloadContractFile = (contractId) => axios.get('/api/enduser/contract/file/'+contractId, { responseType: 'blob' })

const getOtp = (mobilenumber) => axios.post('/api/enduser/otp', { reference: mobilenumber, by_email: false }, { noAuth: true });

const confirmOtp = (otp, mobilenumber, otpToken) => axios.post('/api/enduser/otp/confirm', { otp: otp, reference: mobilenumber, by_email: false }, {
  headers: { Authorization: `Bearer ${otpToken}` }
});

const createUser = (step, data) => axios.post('/api/enduser/kyc/create/' + step, data)
const postUserIDs = (data) => axios.post('/api/enduser/kyc/document', data)

export { getUser, getUserWithDate, getUserContract, streamUserContract, downloadUserContract, getUserContracts, signContract, downloadContractFile, getUserIds, downloadUserId, getFeeList, getOtp, confirmOtp, createUser, postUserIDs, signContractWithoutGsign, signContractDrawn }